import React, {useState} from 'react';
import Header from "../components/Header";
import ContactModal from "../components/ContactModal";

const Impressum = () => {
    const [showModal, setShowModal] = useState(false);
    const toggleModal = () => setShowModal(prev => !prev);
    return (
        <div>
            <Header onContactClick={toggleModal} />
        <div style={styles.container}>
            <h1 style={styles.heading}>Impressum</h1>

            <section style={styles.section}>
                <h2 style={styles.subheading}>Angaben gemäß § 5 TMG</h2>
                <p>
                    Milo & Mabel Hundefriseur Scheyern
                    <br />
                    Susanne Wingens
                    <br />
                    Winden 1a
                    <br />
                    85298 Scheyern
                    <br />
                    Telefon: 08445 – 9295636
                    <br />
                    E-Mail: <a href="mailto:info@hundefriseur-scheyern.de">info@hundefriseur-scheyern.de</a>
                    <br />
                    Website: <a href="https://www.hundefriseur-scheyern.de">www.hundefriseur-scheyern.de</a>
                </p>
            </section>

            <section style={styles.section}>
                <h2 style={styles.subheading}>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
                <p>

                    Susanne Wingens

                </p>
            </section>

            <section style={styles.section}>
                <h2 style={styles.subheading}>Haftungsausschluss</h2>
                <p>
                    Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.


                </p>
            </section>

            <section style={styles.section}>
                <h2 style={styles.subheading}>Urheberrecht</h2>
                <p>
                    Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
            </section>

            <section style={styles.section}>
                <h2 style={styles.subheading}>Streitbeilegung</h2>
                <p>
                    Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die unter https://ec.europa.eu/consumers/odr erreichbar ist. Wir sind nicht verpflichtet, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                </p>
            </section>
            <ContactModal show={showModal} onClose={toggleModal} />
        </div>
        </div>
    );
};
const styles = {
    container: {
        maxWidth: '800px',
        margin: 'auto',
        padding: '2rem',
        fontFamily: 'Arial, sans-serif',
        color: '#333',
        lineHeight: '1.6'
    },
    heading: {
        fontSize: '2rem',
        marginBottom: '1rem'
    },
    subheading: {
        fontSize: '1.2rem',
        marginTop: '1.5rem',
        marginBottom: '0.5rem'
    },
    section: {
        marginBottom: '1.5rem'
    }
};
export default Impressum;